import { render } from "./Order-Number-Input-Field.vue?vue&type=template&id=21ac3496&scoped=true"
import script from "./Order-Number-Input-Field.vue?vue&type=script&lang=js"
export * from "./Order-Number-Input-Field.vue?vue&type=script&lang=js"

import "./Order-Number-Input-Field.vue?vue&type=style&index=0&id=21ac3496&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ac3496"]])

export default __exports__